import styled from 'styled-components';
import { typeScale } from '../../../styles/newTypography';

export const Icons = styled.div`
  transform: translateY(-50%);
  flex-direction: column;
  position: absolute;
  right: 1.5rem;
  display: flex;
  gap: 0.5rem;
`;

export const Icon = styled.div`
  background-color: ${({ theme }) => theme.border100};
  width: 1.25rem;
  height: 0.125rem;

  &.active {
    background-color: ${({ theme }) => theme.border300};
  }
`;

export const List = styled.ul`
  ${typeScale.desktop.body.xs};
  transform: translateY(-50%);
  position: absolute;
  right: 1rem;
  border: 0.0625rem solid ${({ theme }) => theme.bgTranslucentBlack};
  box-shadow: 0 1rem 1.5rem 0 ${({ theme }) => theme.bgTranslucentBlack};
  background-color: ${({ theme }) => theme.bgPrimary};
  backdrop-filter: blur(1.875rem);
  flex-direction: column;
  padding: 1rem 0.5rem;
  list-style: none;
  display: flex;
  gap: 0.5rem;
  margin: 0;
`;

export const Button = styled.button`
  color: ${({ theme }) => theme.text500};
  padding: 0.0625rem 0.5rem;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 11.625rem;
  text-align: left;
  overflow: hidden;
  background: none;
  display: block;
  border: none;
  margin: 0;

  &.active {
    color: ${({ theme }) => theme.textPrimary};
  }

  &:hover {
    color: ${({ theme }) => theme.textPrimary};
    background: ${({ theme }) => theme.bgTranslucentBlack};
  }

  &:focus-visible {
    outline: 0.09375rem solid ${({ theme }) => theme.border.BorderFocus};
  }
`;

export const Table = styled.div`
  position: sticky;
  top: 50%;
  z-index: 1;

  ${Icons} {
    visibility: visible;
  }
  ${List} {
    visibility: hidden;
  }

  &:hover {
    ${Icons} {
      visibility: hidden;
    }
    ${List} {
      visibility: visible;
    }
  }
`;

export const Container = styled.div``;
